import React, { createContext, useContext, useState } from 'react';
import { getVideoBreakdownAPICall } from '../api/video/videoService';
import { useProjectContext } from './useProjectContext';

const VideoContext = createContext();

export const useVideoContext = () => {
  return useContext(VideoContext);
};


export default function VideoContextProvider({ children }) {
  const { selectedProject } = useProjectContext();

  const [videosBreakdown, setVideosBreakdown] = useState([]);
  const [isVideosLoading, setIsVideosLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const loadVideoBreakdown = (page = 1, itemsPerPage = 20, dateFilters = {}) => {
    if (!selectedProject?.id) return;

    setIsVideosLoading(true);
    
    getVideoBreakdownAPICall(
      selectedProject.id,
      page,
      itemsPerPage,
      (response) => {
        const items = response.data?.video_translations || [];
        setVideosBreakdown(items);
        setTotalPages(response.data?.pagination?.total_pages || 1);
        setIsVideosLoading(false);
      },
      (error) => {
        console.error("Failed to fetch video breakdown:", error);
        setIsVideosLoading(false);
      },
      dateFilters
    );
  };

  const value = {
    videosBreakdown,
    isVideosLoading,
    totalPages,
    loadVideoBreakdown,
  };

  return (
    <VideoContext.Provider value={value}>
      {children}
    </VideoContext.Provider>
  );
}